import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";

const Footer = () => (
  <footer className="border-t border-white/10 bg-midnight" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
      <div className="grid md:grid-cols-12 gap-12 md:gap-8">
        <div className="md:col-span-6">
          <Link to="/contact" data-testid="footer-cta" className="group inline-block">
            <p className="text-xs uppercase tracking-[0.25em] text-white/50 mb-4">Have a project in mind?</p>
            <span className="font-sora font-extrabold tracking-tighter text-4xl sm:text-5xl leading-[1.05] block">
              Let's build something
              <span className="text-gradient block">
                worth clicking
                <ArrowUpRight className="inline-block ml-3 w-9 h-9 text-brand-cyan transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </span>
            </span>
          </Link>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-white/50 mb-5">Studio</p>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link className="hover:text-white transition-colors duration-300" to="/services" data-testid="footer-link-services">Services</Link></li>
            <li><Link className="hover:text-white transition-colors duration-300" to="/work" data-testid="footer-link-work">Work</Link></li>
            <li><Link className="hover:text-white transition-colors duration-300" to="/about" data-testid="footer-link-about">About</Link></li>
            <li><Link className="hover:text-white transition-colors duration-300" to="/contact" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-white/50 mb-5">Reach out</p>
          <a
            href="mailto:hello@zilleneal.com"
            data-testid="footer-email"
            className="text-sm text-white/70 hover:text-brand-cyan transition-colors duration-300 block mb-3"
          >
            hello@zilleneal.com
          </a>
          <p className="text-sm text-white/50 flex items-center gap-2">
            <MapPin className="w-4 h-4 text-brand-purple" /> Alberta, Canada
          </p>
        </div>
      </div>

      <div className="mt-20 select-none" aria-hidden>
        <p className="font-sora font-extrabold tracking-tighter leading-none text-[16vw] md:text-[11vw] text-white/[0.04] whitespace-nowrap">
          ZILLENEAL
        </p>
      </div>

      <div className="mt-6 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
        <p>© {new Date().getFullYear()} Zilleneal Digital. All rights reserved.</p>
        <p>Web design studio — Alberta, Canada</p>
      </div>
    </div>
  </footer>
);

export default Footer;
